<template>
  <div class="indicator" :class="status">
    {{ text }}
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
export default {
  name: 'ProgressListItem',
  props: {
    text: String,
    status: String
  }
};
</script>

<style lang="sass" scoped>
.indicator
  padding: 5px;
  width: 80px;
  font-size: 12px;
  border-radius: 15px;
  text-align: center;
.completed
  color: var(--primary-color);
  background-color: var(--primary-color-background);;
.progress
  color: white;
  background-color: var(--primary-color);
.pending
  color: white;
  background-color: var(--background-color);
</style>
